import styled from "styled-components";


export const BirthdayCardContainer = styled.article`
  margin-bottom: 10px;
  padding: 10px 5px;
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
  
  @media (max-width: 760px) {
    -moz-user-select: none; /* Firefox */
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE */
    user-select: none
  }
`

export const BirthdayCardContext = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const BirthdayCardItem = styled.div`
  display: flex;
  flex-direction: column;
`

type BirthdayCardTextProps = {
    color?: string
}

export const BirthdayCardText = styled.p<BirthdayCardTextProps>`
  margin: 0;
  color: ${({color}) => color?.length ? color : "black" };
  
`
